
    /*!
    * Copyright (c) Microsoft Corporation.
    * All rights reserved. See LICENSE in the project root for license information.
    * THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
    * TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
    */
    import {
        AsyncResult,
        callActionOrExecute,
        DataServiceQuery,
        IContext,
        IDataServiceRequest,
        IQueryResultSettings,
        // @ts-ignore -- Unused import
        NullResult
    } from '@msdyn365-commerce/retail-proxy';
    // @ts-ignore -- Unused import
    import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
    // @ts-ignore -- Unused import
    import * as Entities from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
    import * as DataServiceEntities from './DataServiceEntities.g';

    

        // @ts-ignore
        function mxscConfiguratorBuildsQuery(id?: string): DataServiceQuery {
        const key = (id) ? { Id: id } :null;
        return new DataServiceQuery("MxscConfiguratorBuilds", "MxscConfiguratorBuildType", DataServiceEntities.MxscConfiguratorBuildTypeExtensionClass, key);
        }

        
    export function createCreateEmptyBuildInput(buildType: string): IDataServiceRequest {
    const query = mxscConfiguratorBuildsQuery();
    return query.createDataServiceRequestForOperation('CreateEmptyBuild', true, DataServiceEntities.InitializedBuildResultExtensionClass, 'false', {bypassCache: 'get', returnEntity: 'DataServiceEntities.IInitializedBuildResult'}, {buildType: buildType });
    }

    
    export function createEmptyBuildAsync(context: IContext, buildType: string): AsyncResult<DataServiceEntities.IInitializedBuildResult> {
    const request = createCreateEmptyBuildInput(buildType);
    return callActionOrExecute<DataServiceEntities.IInitializedBuildResult>(request, context.callerContext);
    }
  
    export function createGetUserBuildsInput(queryResultSettings: IQueryResultSettings, userId: string): IDataServiceRequest {
    const query = mxscConfiguratorBuildsQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetUserBuilds', true, DataServiceEntities.BuildExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IBuild'}, {userId: userId });
    }

    
    export function getUserBuildsAsync(context: IContext, userId: string): AsyncResult<DataServiceEntities.IBuild[]> {
    const request = createGetUserBuildsInput(
      context.queryResultSettings || {}, userId);
    return callActionOrExecute<DataServiceEntities.IBuild[]>(request, context.callerContext);
    }
  
    export function createGetBuildsByIdsInput(queryResultSettings: IQueryResultSettings, buildIds: string[]): IDataServiceRequest {
    const query = mxscConfiguratorBuildsQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetBuildsByIds', true, DataServiceEntities.BuildExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IBuild'}, {buildIds: buildIds });
    }

    
    export function getBuildsByIdsAsync(context: IContext, buildIds: string[]): AsyncResult<DataServiceEntities.IBuild[]> {
    const request = createGetBuildsByIdsInput(
      context.queryResultSettings || {}, buildIds);
    return callActionOrExecute<DataServiceEntities.IBuild[]>(request, context.callerContext);
    }
  
    export function createInitializeBuildInput(cartId: string, buildId: string, instanceId: string): IDataServiceRequest {
    const query = mxscConfiguratorBuildsQuery();
    return query.createDataServiceRequestForOperation('InitializeBuild', true, DataServiceEntities.InitializedBuildResultExtensionClass, 'false', {bypassCache: 'get', returnEntity: 'DataServiceEntities.IInitializedBuildResult'}, {cartId: cartId, buildId: buildId, instanceId: instanceId });
    }

    
    export function initializeBuildAsync(context: IContext, cartId: string, buildId: string, instanceId: string): AsyncResult<DataServiceEntities.IInitializedBuildResult> {
    const request = createInitializeBuildInput(cartId, buildId, instanceId);
    return callActionOrExecute<DataServiceEntities.IInitializedBuildResult>(request, context.callerContext);
    }
  
    export function createGetValidProductsForSectionInput(build: DataServiceEntities.IBuild, sectionId: string): IDataServiceRequest {
    const query = mxscConfiguratorBuildsQuery();
    return query.createDataServiceRequestForOperation('GetValidProductsForSection', true, DataServiceEntities.GetValidProductsResultExtensionClass, 'false', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IGetValidProductsResult'}, {build: build, sectionId: sectionId });
    }

    
    export function getValidProductsForSectionAsync(context: IContext, build: DataServiceEntities.IBuild, sectionId: string): AsyncResult<DataServiceEntities.IGetValidProductsResult> {
    const request = createGetValidProductsForSectionInput(build, sectionId);
    return callActionOrExecute<DataServiceEntities.IGetValidProductsResult>(request, context.callerContext);
    }
  
    export function createGetValidProductsForExistingSelectionInput(build: DataServiceEntities.IBuild, sectionId: string, selectionId: string): IDataServiceRequest {
    const query = mxscConfiguratorBuildsQuery();
    return query.createDataServiceRequestForOperation('GetValidProductsForExistingSelection', true, DataServiceEntities.GetValidProductsResultExtensionClass, 'false', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IGetValidProductsResult'}, {build: build, sectionId: sectionId, selectionId: selectionId });
    }

    
    export function getValidProductsForExistingSelectionAsync(context: IContext, build: DataServiceEntities.IBuild, sectionId: string, selectionId: string): AsyncResult<DataServiceEntities.IGetValidProductsResult> {
    const request = createGetValidProductsForExistingSelectionInput(build, sectionId, selectionId);
    return callActionOrExecute<DataServiceEntities.IGetValidProductsResult>(request, context.callerContext);
    }
  
    export function createAddProductToBuildInput(build: DataServiceEntities.IBuild, sectionId: string, productId: number, cartId: string, slotIndex: number, selectionId: string): IDataServiceRequest {
    const query = mxscConfiguratorBuildsQuery();
    return query.createDataServiceRequestForOperation('AddProductToBuild', true, DataServiceEntities.BuildExtensionClass, 'false', {bypassCache: 'get', returnEntity: 'DataServiceEntities.IBuild'}, {build: build, sectionId: sectionId, productId: productId, cartId: cartId, slotIndex: slotIndex, selectionId: selectionId });
    }

    
    export function addProductToBuildAsync(context: IContext, build: DataServiceEntities.IBuild, sectionId: string, productId: number, cartId: string, slotIndex: number, selectionId: string): AsyncResult<DataServiceEntities.IBuild> {
    const request = createAddProductToBuildInput(build, sectionId, productId, cartId, slotIndex, selectionId);
    return callActionOrExecute<DataServiceEntities.IBuild>(request, context.callerContext);
    }
  
    export function createRemoveProductFromBuildInput(build: DataServiceEntities.IBuild, buildSelectionId: string, cartId: string): IDataServiceRequest {
    const query = mxscConfiguratorBuildsQuery();
    return query.createDataServiceRequestForOperation('RemoveProductFromBuild', true, DataServiceEntities.BuildExtensionClass, 'false', {bypassCache: 'get', returnEntity: 'DataServiceEntities.IBuild'}, {build: build, buildSelectionId: buildSelectionId, cartId: cartId });
    }

    
    export function removeProductFromBuildAsync(context: IContext, build: DataServiceEntities.IBuild, buildSelectionId: string, cartId: string): AsyncResult<DataServiceEntities.IBuild> {
    const request = createRemoveProductFromBuildInput(build, buildSelectionId, cartId);
    return callActionOrExecute<DataServiceEntities.IBuild>(request, context.callerContext);
    }
  
    export function createUpdateBuildSelectionQuantityInput(build: DataServiceEntities.IBuild, buildSelectionId: string, cartId: string, newQuantity: number): IDataServiceRequest {
    const query = mxscConfiguratorBuildsQuery();
    return query.createDataServiceRequestForOperation('UpdateBuildSelectionQuantity', true, DataServiceEntities.BuildExtensionClass, 'false', {bypassCache: 'get', returnEntity: 'DataServiceEntities.IBuild'}, {build: build, buildSelectionId: buildSelectionId, cartId: cartId, newQuantity: newQuantity });
    }

    
    export function updateBuildSelectionQuantityAsync(context: IContext, build: DataServiceEntities.IBuild, buildSelectionId: string, cartId: string, newQuantity: number): AsyncResult<DataServiceEntities.IBuild> {
    const request = createUpdateBuildSelectionQuantityInput(build, buildSelectionId, cartId, newQuantity);
    return callActionOrExecute<DataServiceEntities.IBuild>(request, context.callerContext);
    }
  
    export function createSaveBuildInput(build: DataServiceEntities.IBuild): IDataServiceRequest {
    const query = mxscConfiguratorBuildsQuery();
    return query.createDataServiceRequestForOperation('SaveBuild', true, '', 'false', {bypassCache: 'get', returnEntity: ''}, {build: build });
    }

    
    export function saveBuildAsync(context: IContext, build: DataServiceEntities.IBuild): AsyncResult<boolean> {
    const request = createSaveBuildInput(build);
    return callActionOrExecute<boolean>(request, context.callerContext);
    }
  
    export function createDeleteBuildInput(buildId: string): IDataServiceRequest {
    const query = mxscConfiguratorBuildsQuery();
    return query.createDataServiceRequestForOperation('DeleteBuild', true, '', 'false', {bypassCache: 'get', returnEntity: ''}, {buildId: buildId });
    }

    
    export function deleteBuildAsync(context: IContext, buildId: string): AsyncResult<boolean> {
    const request = createDeleteBuildInput(buildId);
    return callActionOrExecute<boolean>(request, context.callerContext);
    }
  
    export function createAddBuildToCartInput(build: DataServiceEntities.IBuild, cartId: string): IDataServiceRequest {
    const query = mxscConfiguratorBuildsQuery();
    return query.createDataServiceRequestForOperation('AddBuildToCart', true, EntityClasses.CartClass, 'false', {bypassCache: 'get', returnEntity: 'Entities.Cart'}, {build: build, cartId: cartId });
    }

    
    export function addBuildToCartAsync(context: IContext, build: DataServiceEntities.IBuild, cartId: string): AsyncResult<Entities.Cart> {
    const request = createAddBuildToCartInput(build, cartId);
    return callActionOrExecute<Entities.Cart>(request, context.callerContext);
    }
  
    export function createGetValidConfiguratorTypesInput(): IDataServiceRequest {
    const query = mxscConfiguratorBuildsQuery();
    return query.createDataServiceRequestForOperation('GetValidConfiguratorTypes', true, DataServiceEntities.GetValidConfiguratorTypesResponseExtensionClass, 'false', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IGetValidConfiguratorTypesResponse'}, { });
    }

    
    export function getValidConfiguratorTypesAsync(context: IContext): AsyncResult<DataServiceEntities.IGetValidConfiguratorTypesResponse> {
    const request = createGetValidConfiguratorTypesInput();
    return callActionOrExecute<DataServiceEntities.IGetValidConfiguratorTypesResponse>(request, context.callerContext);
    }
  

        // @ts-ignore
        function memxWarrantyQuery(id?: number): DataServiceQuery {
        const key = (id) ? { Id: id } :null;
        return new DataServiceQuery("MemxWarranty", "WarrantyType", DataServiceEntities.WarrantyTypeExtensionClass, key);
        }

        
    export function createGetWarrantyIconsInput(queryResultSettings: IQueryResultSettings): IDataServiceRequest {
    const query = memxWarrantyQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetWarrantyIcons', true, DataServiceEntities.WarrantyIconExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IWarrantyIcon'}, { });
    }

    
    export function getWarrantyIconsAsync(context: IContext): AsyncResult<DataServiceEntities.IWarrantyIcon[]> {
    const request = createGetWarrantyIconsInput(
      context.queryResultSettings || {}, );
    return callActionOrExecute<DataServiceEntities.IWarrantyIcon[]>(request, context.callerContext);
    }
  
    export function createUpdateWarrantySelectionsInput(cart: Entities.Cart, lineSelections: DataServiceEntities.IWarrantyLineSelection[]): IDataServiceRequest {
    const query = memxWarrantyQuery();
    return query.createDataServiceRequestForOperation('UpdateWarrantySelections', true, EntityClasses.CartClass, 'false', {bypassCache: 'get', returnEntity: 'Entities.Cart'}, {cart: cart, lineSelections: lineSelections });
    }

    
    export function updateWarrantySelectionsAsync(context: IContext, cart: Entities.Cart, lineSelections: DataServiceEntities.IWarrantyLineSelection[]): AsyncResult<Entities.Cart> {
    const request = createUpdateWarrantySelectionsInput(cart, lineSelections);
    return callActionOrExecute<Entities.Cart>(request, context.callerContext);
    }
  
    export function createUpdateGroupedWarrantySelectionsInput(cart: Entities.Cart, lineSelections: DataServiceEntities.IWarrantyLineSelection[]): IDataServiceRequest {
    const query = memxWarrantyQuery();
    return query.createDataServiceRequestForOperation('UpdateGroupedWarrantySelections', true, EntityClasses.CartClass, 'false', {bypassCache: 'get', returnEntity: 'Entities.Cart'}, {cart: cart, lineSelections: lineSelections });
    }

    
    export function updateGroupedWarrantySelectionsAsync(context: IContext, cart: Entities.Cart, lineSelections: DataServiceEntities.IWarrantyLineSelection[]): AsyncResult<Entities.Cart> {
    const request = createUpdateGroupedWarrantySelectionsInput(cart, lineSelections);
    return callActionOrExecute<Entities.Cart>(request, context.callerContext);
    }
  
    export function createGetProductWarrantiesInput(queryResultSettings: IQueryResultSettings, productIds: number[]): IDataServiceRequest {
    const query = memxWarrantyQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetProductWarranties', true, DataServiceEntities.ProductWarrantiesExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IProductWarranties'}, {productIds: productIds });
    }

    
    export function getProductWarrantiesAsync(context: IContext, productIds: number[]): AsyncResult<DataServiceEntities.IProductWarranties[]> {
    const request = createGetProductWarrantiesInput(
      context.queryResultSettings || {}, productIds);
    return callActionOrExecute<DataServiceEntities.IProductWarranties[]>(request, context.callerContext);
    }
  
    export function createGetGroupedProductWarrantiesInput(queryResultSettings: IQueryResultSettings, products: DataServiceEntities.IProductQuantityPair[], groupingProductId: number): IDataServiceRequest {
    const query = memxWarrantyQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetGroupedProductWarranties', true, DataServiceEntities.ProductWarrantiesExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IProductWarranties'}, {products: products, groupingProductId: groupingProductId });
    }

    
    export function getGroupedProductWarrantiesAsync(context: IContext, products: DataServiceEntities.IProductQuantityPair[], groupingProductId: number): AsyncResult<DataServiceEntities.IProductWarranties[]> {
    const request = createGetGroupedProductWarrantiesInput(
      context.queryResultSettings || {}, products, groupingProductId);
    return callActionOrExecute<DataServiceEntities.IProductWarranties[]>(request, context.callerContext);
    }
  
    export function createGetCustomerWarrantyPoliciesInput(queryResultSettings: IQueryResultSettings, searchCriteria: DataServiceEntities.IWarrantySearchCriteria): IDataServiceRequest {
    const query = memxWarrantyQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetCustomerWarrantyPolicies', true, DataServiceEntities.WarrantyPolicyExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IWarrantyPolicy'}, {searchCriteria: searchCriteria });
    }

    
    export function getCustomerWarrantyPoliciesAsync(context: IContext, searchCriteria: DataServiceEntities.IWarrantySearchCriteria): AsyncResult<DataServiceEntities.IWarrantyPolicy[]> {
    const request = createGetCustomerWarrantyPoliciesInput(
      context.queryResultSettings || {}, searchCriteria);
    return callActionOrExecute<DataServiceEntities.IWarrantyPolicy[]>(request, context.callerContext);
    }
  
    export function createGetProductDefaultVariantsInput(queryResultSettings: IQueryResultSettings, productIds: number[]): IDataServiceRequest {
    const query = memxWarrantyQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetProductDefaultVariants', true, DataServiceEntities.ProductDefaultVariantExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IProductDefaultVariant'}, {productIds: productIds });
    }

    
    export function getProductDefaultVariantsAsync(context: IContext, productIds: number[]): AsyncResult<DataServiceEntities.IProductDefaultVariant[]> {
    const request = createGetProductDefaultVariantsInput(
      context.queryResultSettings || {}, productIds);
    return callActionOrExecute<DataServiceEntities.IProductDefaultVariant[]>(request, context.callerContext);
    }
  
    export function createGetWarrantyHistoryInput(queryResultSettings: IQueryResultSettings, policyId: string): IDataServiceRequest {
    const query = memxWarrantyQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetWarrantyHistory', true, DataServiceEntities.WarrantyHistoryLineExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IWarrantyHistoryLine'}, {policyId: policyId });
    }

    
    export function getWarrantyHistoryAsync(context: IContext, policyId: string): AsyncResult<DataServiceEntities.IWarrantyHistoryLine[]> {
    const request = createGetWarrantyHistoryInput(
      context.queryResultSettings || {}, policyId);
    return callActionOrExecute<DataServiceEntities.IWarrantyHistoryLine[]>(request, context.callerContext);
    }
  

        // @ts-ignore
        function mEMXSynchronizeQuery(id?: number): DataServiceQuery {
        const key = (id) ? { Id: id } :null;
        return new DataServiceQuery("MEMXSynchronize", "MemxSynchronizeType", DataServiceEntities.MemxSynchronizeTypeExtensionClass, key);
        }

        
    export function createBeginReadChangedProductsInput(changedProductSearchCriteria: Entities.ChangedProductsSearchCriteria): IDataServiceRequest {
    const query = mEMXSynchronizeQuery();
    return query.createDataServiceRequestForOperation('BeginReadChangedProducts', true, EntityClasses.ReadChangedProductsSessionClass, 'false', {bypassCache: 'get', returnEntity: 'Entities.ReadChangedProductsSession'}, {changedProductSearchCriteria: changedProductSearchCriteria });
    }

    
    export function beginReadChangedProductsAsync(context: IContext, changedProductSearchCriteria: Entities.ChangedProductsSearchCriteria): AsyncResult<Entities.ReadChangedProductsSession> {
    const request = createBeginReadChangedProductsInput(changedProductSearchCriteria);
    return callActionOrExecute<Entities.ReadChangedProductsSession>(request, context.callerContext);
    }
  
    export function createReadChangedProductsInput(queryResultSettings: IQueryResultSettings, productSearchCriteria: Entities.ChangedProductsSearchCriteria, skipProductPriceCalculation: boolean): IDataServiceRequest {
    const query = mEMXSynchronizeQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('ReadChangedProducts', true, EntityClasses.ProductClass, 'true', {bypassCache: 'none', returnEntity: 'Entities.Product'}, {productSearchCriteria: productSearchCriteria, skipProductPriceCalculation: skipProductPriceCalculation });
    }

    
    export function readChangedProductsAsync(context: IContext, productSearchCriteria: Entities.ChangedProductsSearchCriteria, skipProductPriceCalculation: boolean): AsyncResult<Entities.Product[]> {
    const request = createReadChangedProductsInput(
      context.queryResultSettings || {}, productSearchCriteria, skipProductPriceCalculation);
    return callActionOrExecute<Entities.Product[]>(request, context.callerContext);
    }
  
    export function createEndReadChangedProductsInput(session: Entities.ReadChangedProductsSession): IDataServiceRequest {
    const query = mEMXSynchronizeQuery();
    return query.createDataServiceRequestForOperation('EndReadChangedProducts', true, '', 'false', {bypassCache: 'get', returnEntity: ''}, {session: session });
    }

    
    export function endReadChangedProductsAsync(context: IContext, session: Entities.ReadChangedProductsSession): AsyncResult<boolean> {
    const request = createEndReadChangedProductsInput(session);
    return callActionOrExecute<boolean>(request, context.callerContext);
    }
  
    export function createCleanChangedProductsSessionsInput(olderThanDays: number): IDataServiceRequest {
    const query = mEMXSynchronizeQuery();
    return query.createDataServiceRequestForOperation('CleanChangedProductsSessions', true, '', 'false', {bypassCache: 'get', returnEntity: ''}, {olderThanDays: olderThanDays });
    }

    
    export function cleanChangedProductsSessionsAsync(context: IContext, olderThanDays: number): AsyncResult<boolean> {
    const request = createCleanChangedProductsSessionsInput(olderThanDays);
    return callActionOrExecute<boolean>(request, context.callerContext);
    }
  

        // @ts-ignore
        function memxShippingQuery(shipmentId?: string): DataServiceQuery {
        const key = (shipmentId) ? { ShipmentId: shipmentId } :null;
        return new DataServiceQuery("MemxShipping", "Shipment", DataServiceEntities.ShipmentExtensionClass, key);
        }

        
    export function createGetPackingSlipsDataInput(queryResultSettings: IQueryResultSettings, salesId: string): IDataServiceRequest {
    const query = memxShippingQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetPackingSlipsData', true, EntityClasses.PackingSlipDataClass, 'true', {bypassCache: 'none', returnEntity: 'Entities.PackingSlipData'}, {salesId: salesId });
    }

    
    export function getPackingSlipsDataAsync(context: IContext, salesId: string): AsyncResult<Entities.PackingSlipData[]> {
    const request = createGetPackingSlipsDataInput(
      context.queryResultSettings || {}, salesId);
    return callActionOrExecute<Entities.PackingSlipData[]>(request, context.callerContext);
    }
  
    export function createCreateShipmentInput(criteria: DataServiceEntities.ICreateShipmentCriteria): IDataServiceRequest {
    const query = memxShippingQuery();
    return query.createDataServiceRequestForOperation('CreateShipment', true, DataServiceEntities.ShipmentExtensionClass, 'false', {bypassCache: 'get', returnEntity: 'DataServiceEntities.IShipment'}, {criteria: criteria });
    }

    
    export function createShipmentAsync(context: IContext, criteria: DataServiceEntities.ICreateShipmentCriteria): AsyncResult<DataServiceEntities.IShipment> {
    const request = createCreateShipmentInput(criteria);
    return callActionOrExecute<DataServiceEntities.IShipment>(request, context.callerContext);
    }
  
    export function createPurchaseShipmentInput(rate: DataServiceEntities.IShipmentRate, orderId: string, packingslipIds: string[], orderType: string, parcels: DataServiceEntities.IParcel[]): IDataServiceRequest {
    const query = memxShippingQuery();
    return query.createDataServiceRequestForOperation('PurchaseShipment', true, DataServiceEntities.ShipmentTransactionExtensionClass, 'false', {bypassCache: 'get', returnEntity: 'DataServiceEntities.IShipmentTransaction'}, {rate: rate, orderId: orderId, packingslipIds: packingslipIds, orderType: orderType, parcels: parcels });
    }

    
    export function purchaseShipmentAsync(context: IContext, rate: DataServiceEntities.IShipmentRate, orderId: string, packingslipIds: string[], orderType: string, parcels: DataServiceEntities.IParcel[]): AsyncResult<DataServiceEntities.IShipmentTransaction> {
    const request = createPurchaseShipmentInput(rate, orderId, packingslipIds, orderType, parcels);
    return callActionOrExecute<DataServiceEntities.IShipmentTransaction>(request, context.callerContext);
    }
  
    export function createSavePackingSlipTrackingInput(salesId: string, packingSlipId: string, trackingNum: string, trackingUrl: string): IDataServiceRequest {
    const query = memxShippingQuery();
    return query.createDataServiceRequestForOperation('SavePackingSlipTracking', true, '', 'false', {bypassCache: 'get', returnEntity: ''}, {salesId: salesId, packingSlipId: packingSlipId, trackingNum: trackingNum, trackingUrl: trackingUrl });
    }

    
    export function savePackingSlipTrackingAsync(context: IContext, salesId: string, packingSlipId: string, trackingNum: string, trackingUrl: string): AsyncResult<boolean> {
    const request = createSavePackingSlipTrackingInput(salesId, packingSlipId, trackingNum, trackingUrl);
    return callActionOrExecute<boolean>(request, context.callerContext);
    }
  
    export function createGetPuchasedShipmentDataInput(queryResultSettings: IQueryResultSettings, salesId: string, packingSlipId: string): IDataServiceRequest {
    const query = memxShippingQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetPuchasedShipmentData', true, DataServiceEntities.ShipmentTransactionExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IShipmentTransaction'}, {salesId: salesId, packingSlipId: packingSlipId });
    }

    
    export function getPuchasedShipmentDataAsync(context: IContext, salesId: string, packingSlipId: string): AsyncResult<DataServiceEntities.IShipmentTransaction[]> {
    const request = createGetPuchasedShipmentDataInput(
      context.queryResultSettings || {}, salesId, packingSlipId);
    return callActionOrExecute<DataServiceEntities.IShipmentTransaction[]>(request, context.callerContext);
    }
  
    export function createGetShippingCarrierServicesInput(queryResultSettings: IQueryResultSettings, deliveryMode: string): IDataServiceRequest {
    const query = memxShippingQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetShippingCarrierServices', true, DataServiceEntities.CarrierServiceExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.ICarrierService'}, {deliveryMode: deliveryMode });
    }

    
    export function getShippingCarrierServicesAsync(context: IContext, deliveryMode: string): AsyncResult<DataServiceEntities.ICarrierService[]> {
    const request = createGetShippingCarrierServicesInput(
      context.queryResultSettings || {}, deliveryMode);
    return callActionOrExecute<DataServiceEntities.ICarrierService[]>(request, context.callerContext);
    }
  
    export function createMEMXGetPickingListsInput(queryResultSettings: IQueryResultSettings, salesIds: string[], hardwareProfileID: string): IDataServiceRequest {
    const query = memxShippingQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('MEMXGetPickingLists', true, EntityClasses.ReceiptClass, 'true', {bypassCache: 'get', returnEntity: 'Entities.Receipt'}, {salesIds: salesIds, hardwareProfileID: hardwareProfileID });
    }

    
    export function mEMXGetPickingListsAsync(context: IContext, salesIds: string[], hardwareProfileID: string): AsyncResult<Entities.Receipt[]> {
    const request = createMEMXGetPickingListsInput(
      context.queryResultSettings || {}, salesIds, hardwareProfileID);
    return callActionOrExecute<Entities.Receipt[]>(request, context.callerContext);
    }
  
    export function createMEMXGetAdditionalFulfillmentDataInput(orderId: string, deliveryAddress: number): IDataServiceRequest {
    const query = memxShippingQuery();
    return query.createDataServiceRequestForOperation('MEMXGetAdditionalFulfillmentData', true, DataServiceEntities.MemxFulfillmentAdditionalDataExtensionClass, 'false', {bypassCache: 'get', returnEntity: 'DataServiceEntities.IMemxFulfillmentAdditionalData'}, {orderId: orderId, deliveryAddress: deliveryAddress });
    }

    
    export function mEMXGetAdditionalFulfillmentDataAsync(context: IContext, orderId: string, deliveryAddress: number): AsyncResult<DataServiceEntities.IMemxFulfillmentAdditionalData> {
    const request = createMEMXGetAdditionalFulfillmentDataInput(orderId, deliveryAddress);
    return callActionOrExecute<DataServiceEntities.IMemxFulfillmentAdditionalData>(request, context.callerContext);
    }
  

        // @ts-ignore
        function memxEcommerceQuery(id?: string): DataServiceQuery {
        const key = (id) ? { Id: id } :null;
        return new DataServiceQuery("MemxEcommerce", "MemxEcommerceType", DataServiceEntities.MemxEcommerceTypeExtensionClass, key);
        }

        
    export function createSendFeedbackInput(formValues: DataServiceEntities.IMailFormValues, recaptchaResponse: string): IDataServiceRequest {
    const query = memxEcommerceQuery();
    return query.createDataServiceRequestForOperation('SendFeedback', true, DataServiceEntities.FeedbackResultStatusExtensionClass, 'false', {bypassCache: 'get', returnEntity: 'DataServiceEntities.IFeedbackResultStatus'}, {formValues: formValues, recaptchaResponse: recaptchaResponse });
    }

    
    export function sendFeedbackAsync(context: IContext, formValues: DataServiceEntities.IMailFormValues, recaptchaResponse: string): AsyncResult<DataServiceEntities.IFeedbackResultStatus> {
    const request = createSendFeedbackInput(formValues, recaptchaResponse);
    return callActionOrExecute<DataServiceEntities.IFeedbackResultStatus>(request, context.callerContext);
    }
  
    export function createValidateCaptchaInput(recaptchaResponse: string): IDataServiceRequest {
    const query = memxEcommerceQuery();
    return query.createDataServiceRequestForOperation('ValidateCaptcha', true, DataServiceEntities.CaptchaResponseExtensionClass, 'false', {bypassCache: 'get', returnEntity: 'DataServiceEntities.ICaptchaResponse'}, {recaptchaResponse: recaptchaResponse });
    }

    
    export function validateCaptchaAsync(context: IContext, recaptchaResponse: string): AsyncResult<DataServiceEntities.ICaptchaResponse> {
    const request = createValidateCaptchaInput(recaptchaResponse);
    return callActionOrExecute<DataServiceEntities.ICaptchaResponse>(request, context.callerContext);
    }
  
    export function createActivateOnlineGiftCardInput(cardNumber: string, pin: string, activationCode: string): IDataServiceRequest {
    const query = memxEcommerceQuery();
    return query.createDataServiceRequestForOperation('ActivateOnlineGiftCard', true, '', 'false', {bypassCache: 'get', returnEntity: ''}, {cardNumber: cardNumber, pin: pin, activationCode: activationCode });
    }

    
    export function activateOnlineGiftCardAsync(context: IContext, cardNumber: string, pin: string, activationCode: string): AsyncResult<boolean> {
    const request = createActivateOnlineGiftCardInput(cardNumber, pin, activationCode);
    return callActionOrExecute<boolean>(request, context.callerContext);
    }
  

        // @ts-ignore
        function memxCoreQuery(id?: number): DataServiceQuery {
        const key = (id) ? { Id: id } :null;
        return new DataServiceQuery("MemxCore", "MemxCoreType", DataServiceEntities.MemxCoreTypeExtensionClass, key);
        }

        
    export function createSearchOrdersInput(queryResultSettings: IQueryResultSettings, searchCriteria: Entities.OrderSearchCriteria): IDataServiceRequest {
    const query = memxCoreQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('SearchOrders', true, EntityClasses.SalesOrderClass, 'true', {bypassCache: 'none', returnEntity: 'Entities.SalesOrder'}, {searchCriteria: searchCriteria });
    }

    
    export function searchOrdersAsync(context: IContext, searchCriteria: Entities.OrderSearchCriteria): AsyncResult<Entities.SalesOrder[]> {
    const request = createSearchOrdersInput(
      context.queryResultSettings || {}, searchCriteria);
    return callActionOrExecute<Entities.SalesOrder[]>(request, context.callerContext);
    }
  
    export function createUpdateCartLinesInput(cartId: string, cartLine: Entities.CartLine[], cartVersion: number): IDataServiceRequest {
    const query = memxCoreQuery();
    return query.createDataServiceRequestForOperation('UpdateCartLines', true, EntityClasses.CartClass, 'false', {bypassCache: 'get', returnEntity: 'Entities.Cart'}, {cartId: cartId, cartLine: cartLine, cartVersion: cartVersion });
    }

    
    export function updateCartLinesAsync(context: IContext, cartId: string, cartLine: Entities.CartLine[], cartVersion: number): AsyncResult<Entities.Cart> {
    const request = createUpdateCartLinesInput(cartId, cartLine, cartVersion);
    return callActionOrExecute<Entities.Cart>(request, context.callerContext);
    }
  

        // @ts-ignore
        function channelDataQuery(recordId?: number): DataServiceQuery {
        const key = (recordId) ? { RecordId: recordId } :null;
        return new DataServiceQuery("ChannelData", "MMX_RetailParameters", DataServiceEntities.MMX_RetailParametersExtensionClass, key);
        }

        
    export function createGetMMX_RetailParametersInput(): IDataServiceRequest {
    const query = channelDataQuery();
    return query.createDataServiceRequestForOperation('GetMMX_RetailParameters', true, DataServiceEntities.MMX_RetailParametersExtensionClass, 'false', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IMMX_RetailParameters'}, { });
    }

    
    export function getMMX_RetailParametersAsync(context: IContext): AsyncResult<DataServiceEntities.IMMX_RetailParameters> {
    const request = createGetMMX_RetailParametersInput();
    return callActionOrExecute<DataServiceEntities.IMMX_RetailParameters>(request, context.callerContext);
    }
  
    export function createGetReturnReasonCodesInput(queryResultSettings: IQueryResultSettings): IDataServiceRequest {
    const query = channelDataQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetReturnReasonCodes', true, EntityClasses.ReasonCodeClass, 'true', {bypassCache: 'none', returnEntity: 'Entities.ReasonCode'}, { });
    }

    
    export function getReturnReasonCodesAsync(context: IContext): AsyncResult<Entities.ReasonCode[]> {
    const request = createGetReturnReasonCodesInput(
      context.queryResultSettings || {}, );
    return callActionOrExecute<Entities.ReasonCode[]>(request, context.callerContext);
    }
  
    // export function createMEMXGetRetailConfigurationParametersInput(queryResultSettings: IQueryResultSettings, parameterName: string): IDataServiceRequest {
    // const query = channelDataQuery().resultSettings(queryResultSettings);
    // return query.createDataServiceRequestForOperation('MEMXGetRetailConfigurationParameters', true, EntityClasses.MEMXRetailConfigurationParameterClass, 'true', {bypassCache: 'get', returnEntity: 'Entities.MEMXRetailConfigurationParameter'}, {parameterName: parameterName });
    // }

    
    // export function mEMXGetRetailConfigurationParametersAsync(context: IContext, parameterName: string): AsyncResult<Entities.MEMXRetailConfigurationParameter[]> {
    // const request = createMEMXGetRetailConfigurationParametersInput(
    //   context.queryResultSettings || {}, parameterName);
    // return callActionOrExecute<Entities.MEMXRetailConfigurationParameter[]>(request, context.callerContext);
    // }
  

        // @ts-ignore
        function mEMXServiceQuery(serviceId?: string): DataServiceQuery {
        const key = (serviceId) ? { ServiceId: serviceId } :null;
        return new DataServiceQuery("MEMXService", "ServiceItemInfo", DataServiceEntities.ServiceItemInfoExtensionClass, key);
        }

        
    export function createGetAuditLogInfoInput(queryResultSettings: IQueryResultSettings, cartId: string, salesId: string): IDataServiceRequest {
    const query = mEMXServiceQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetAuditLogInfo', true, DataServiceEntities.AuditLogEntryExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IAuditLogEntry'}, {cartId: cartId, salesId: salesId });
    }

    
    export function getAuditLogInfoAsync(context: IContext, cartId: string, salesId: string): AsyncResult<DataServiceEntities.IAuditLogEntry[]> {
    const request = createGetAuditLogInfoInput(
      context.queryResultSettings || {}, cartId, salesId);
    return callActionOrExecute<DataServiceEntities.IAuditLogEntry[]>(request, context.callerContext);
    }
  
    export function createUpdateAuditLogInfoInput(cartId: string, salesId: string, auditLogList: DataServiceEntities.IAuditLogEntry[]): IDataServiceRequest {
    const query = mEMXServiceQuery();
    return query.createDataServiceRequestForOperation('UpdateAuditLogInfo', true, '', 'false', {bypassCache: 'get', returnEntity: ''}, {cartId: cartId, salesId: salesId, auditLogList: auditLogList });
    }

    
    export function updateAuditLogInfoAsync(context: IContext, cartId: string, salesId: string, auditLogList: DataServiceEntities.IAuditLogEntry[]): AsyncResult<boolean> {
    const request = createUpdateAuditLogInfoInput(cartId, salesId, auditLogList);
    return callActionOrExecute<boolean>(request, context.callerContext);
    }
  
    export function createGetNewServiceSerialIdInput(): IDataServiceRequest {
    const query = mEMXServiceQuery();
    return query.createDataServiceRequestForOperation('GetNewServiceSerialId', true, '', 'false', {bypassCache: 'none', returnEntity: ''}, { });
    }

    
    export function getNewServiceSerialIdAsync(context: IContext): AsyncResult<string> {
    const request = createGetNewServiceSerialIdInput();
    return callActionOrExecute<string>(request, context.callerContext);
    }
  

        // @ts-ignore
        function memxCommerceQuery(id?: number): DataServiceQuery {
        const key = (id) ? { Id: id } :null;
        return new DataServiceQuery("MemxCommerce", "MemxCommerceType", DataServiceEntities.MemxCommerceTypeExtensionClass, key);
        }

        
    export function createGetProductCostsInput(queryResultSettings: IQueryResultSettings, productIds: number[]): IDataServiceRequest {
    const query = memxCommerceQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetProductCosts', true, DataServiceEntities.ProductCostExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IProductCost'}, {productIds: productIds });
    }

    
    export function getProductCostsAsync(context: IContext, productIds: number[]): AsyncResult<DataServiceEntities.IProductCost[]> {
    const request = createGetProductCostsInput(
      context.queryResultSettings || {}, productIds);
    return callActionOrExecute<DataServiceEntities.IProductCost[]>(request, context.callerContext);
    }
  
    export function createGetCustomerCreditMemoListInput(queryResultSettings: IQueryResultSettings, custAccount: string): IDataServiceRequest {
    const query = memxCommerceQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetCustomerCreditMemoList', true, DataServiceEntities.CreditMemoInfoExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.ICreditMemoInfo'}, {custAccount: custAccount });
    }

    
    export function getCustomerCreditMemoListAsync(context: IContext, custAccount: string): AsyncResult<DataServiceEntities.ICreditMemoInfo[]> {
    const request = createGetCustomerCreditMemoListInput(
      context.queryResultSettings || {}, custAccount);
    return callActionOrExecute<DataServiceEntities.ICreditMemoInfo[]>(request, context.callerContext);
    }
  
    export function createGetCustomerMemoInput(custAccount: string): IDataServiceRequest {
    const query = memxCommerceQuery();
    return query.createDataServiceRequestForOperation('GetCustomerMemo', true, DataServiceEntities.GetCustomerMemoInfoExtensionClass, 'false', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IGetCustomerMemoInfo'}, {custAccount: custAccount });
    }

    
    export function getCustomerMemoAsync(context: IContext, custAccount: string): AsyncResult<DataServiceEntities.IGetCustomerMemoInfo> {
    const request = createGetCustomerMemoInput(custAccount);
    return callActionOrExecute<DataServiceEntities.IGetCustomerMemoInfo>(request, context.callerContext);
    }
  
    export function createUpdateCustomerMemoInput(custAccount: string, memo: string): IDataServiceRequest {
    const query = memxCommerceQuery();
    return query.createDataServiceRequestForOperation('UpdateCustomerMemo', true, '', 'false', {bypassCache: 'get', returnEntity: ''}, {custAccount: custAccount, memo: memo });
    }

    
    export function updateCustomerMemoAsync(context: IContext, custAccount: string, memo: string): AsyncResult<boolean> {
    const request = createUpdateCustomerMemoInput(custAccount, memo);
    return callActionOrExecute<boolean>(request, context.callerContext);
    }
  
    export function createUpdateToEditInput(cartId: string, cartVersion: number): IDataServiceRequest {
    const query = memxCommerceQuery();
    return query.createDataServiceRequestForOperation('UpdateToEdit', true, EntityClasses.CartClass, 'false', {bypassCache: 'get', returnEntity: 'Entities.Cart'}, {cartId: cartId, cartVersion: cartVersion });
    }

    
    export function updateToEditAsync(context: IContext, cartId: string, cartVersion: number): AsyncResult<Entities.Cart> {
    const request = createUpdateToEditInput(cartId, cartVersion);
    return callActionOrExecute<Entities.Cart>(request, context.callerContext);
    }
  
    export function createSearchAllCommissionsGroupInput(queryResultSettings: IQueryResultSettings, searchText: string, skipCount: number, pageSize: number): IDataServiceRequest {
    const query = memxCommerceQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('SearchAllCommissionsGroup', true, EntityClasses.CommissionSalesGroupClass, 'true', {bypassCache: 'none', returnEntity: 'Entities.CommissionSalesGroup'}, {searchText: searchText, skipCount: skipCount, pageSize: pageSize });
    }

    
    export function searchAllCommissionsGroupAsync(context: IContext, searchText: string, skipCount: number, pageSize: number): AsyncResult<Entities.CommissionSalesGroup[]> {
    const request = createSearchAllCommissionsGroupInput(
      context.queryResultSettings || {}, searchText, skipCount, pageSize);
    return callActionOrExecute<Entities.CommissionSalesGroup[]>(request, context.callerContext);
    }
  
    export function createGetCustomerStoredCardsInput(queryResultSettings: IQueryResultSettings, custAccount: string): IDataServiceRequest {
    const query = memxCommerceQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetCustomerStoredCards', true, DataServiceEntities.MemxStoredCardExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IMemxStoredCard'}, {custAccount: custAccount });
    }

    
    export function getCustomerStoredCardsAsync(context: IContext, custAccount: string): AsyncResult<DataServiceEntities.IMemxStoredCard[]> {
    const request = createGetCustomerStoredCardsInput(
      context.queryResultSettings || {}, custAccount);
    return callActionOrExecute<DataServiceEntities.IMemxStoredCard[]>(request, context.callerContext);
    }
  
    export function createGetLocalPaymentConnectorForCardTokenInput(cardToken: string): IDataServiceRequest {
    const query = memxCommerceQuery();
    return query.createDataServiceRequestForOperation('GetLocalPaymentConnectorForCardToken', true, EntityClasses.CardTokenInfoClass, 'false', {bypassCache: 'none', returnEntity: 'Entities.CardTokenInfo'}, {cardToken: cardToken });
    }

    
    export function getLocalPaymentConnectorForCardTokenAsync(context: IContext, cardToken: string): AsyncResult<Entities.CardTokenInfo> {
    const request = createGetLocalPaymentConnectorForCardTokenInput(cardToken);
    return callActionOrExecute<Entities.CardTokenInfo>(request, context.callerContext);
    }
  
    export function createGetFormattedPaymentHistoryInput(queryResultSettings: IQueryResultSettings, cartId: string): IDataServiceRequest {
    const query = memxCommerceQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetFormattedPaymentHistory', true, EntityClasses.TenderLineClass, 'true', {bypassCache: 'none', returnEntity: 'Entities.TenderLine'}, {cartId: cartId });
    }

    
    export function getFormattedPaymentHistoryAsync(context: IContext, cartId: string): AsyncResult<Entities.TenderLine[]> {
    const request = createGetFormattedPaymentHistoryInput(
      context.queryResultSettings || {}, cartId);
    return callActionOrExecute<Entities.TenderLine[]>(request, context.callerContext);
    }
  
    export function createUpdateCustomerOrderChangeCustomerInput(salesId: string, custAccount: string): IDataServiceRequest {
    const query = memxCommerceQuery();
    return query.createDataServiceRequestForOperation('UpdateCustomerOrderChangeCustomer', true, '', 'false', {bypassCache: 'get', returnEntity: ''}, {salesId: salesId, custAccount: custAccount });
    }

    
    export function updateCustomerOrderChangeCustomerAsync(context: IContext, salesId: string, custAccount: string): AsyncResult<boolean> {
    const request = createUpdateCustomerOrderChangeCustomerInput(salesId, custAccount);
    return callActionOrExecute<boolean>(request, context.callerContext);
    }
  
    // export function createGetSerialStockForCartInput(queryResultSettings: IQueryResultSettings, cartLines: Entities.CartLine[]): IDataServiceRequest {
    // const query = memxCommerceQuery().resultSettings(queryResultSettings);
    // return query.createDataServiceRequestForOperation('GetSerialStockForCart', true, EntityClasses.ItemOnHandQuantityClass, 'true', {bypassCache: 'none', returnEntity: 'Entities.ItemOnHandQuantity'}, {cartLines: cartLines });
    // }

    
    // export function getSerialStockForCartAsync(context: IContext, cartLines: Entities.CartLine[]): AsyncResult<Entities.ItemOnHandQuantity[]> {
    // const request = createGetSerialStockForCartInput(
    //   context.queryResultSettings || {}, cartLines);
    // return callActionOrExecute<Entities.ItemOnHandQuantity[]>(request, context.callerContext);
    // }
  
    export function createUpdateRegisterThemeInput(theme: string): IDataServiceRequest {
    const query = memxCommerceQuery();
    return query.createDataServiceRequestForOperation('UpdateRegisterTheme', true, '', 'false', {bypassCache: 'get', returnEntity: ''}, {theme: theme });
    }

    
    export function updateRegisterThemeAsync(context: IContext, theme: string): AsyncResult<boolean> {
    const request = createUpdateRegisterThemeInput(theme);
    return callActionOrExecute<boolean>(request, context.callerContext);
    }
  

        // @ts-ignore
        function memxDiscountQuery(offerId?: string): DataServiceQuery {
        const key = (offerId) ? { OfferId: offerId } :null;
        return new DataServiceQuery("MemxDiscount", "MixAndMatchDiscount", DataServiceEntities.MixAndMatchDiscountExtensionClass, key);
        }

        
    export function createGetApprovedCompetitorsInput(queryResultSettings: IQueryResultSettings): IDataServiceRequest {
    const query = memxDiscountQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetApprovedCompetitors', true, DataServiceEntities.ApprovedCompetitorExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IApprovedCompetitor'}, { });
    }

    
    export function getApprovedCompetitorsAsync(context: IContext): AsyncResult<DataServiceEntities.IApprovedCompetitor[]> {
    const request = createGetApprovedCompetitorsInput(
      context.queryResultSettings || {}, );
    return callActionOrExecute<DataServiceEntities.IApprovedCompetitor[]>(request, context.callerContext);
    }
  
    export function createSetPriceBeatOnCartLineInput(cartId: string, cartLine: Entities.CartLine, competitorPrice: number, competitorUrl: string, competitorName: string): IDataServiceRequest {
    const query = memxDiscountQuery();
    return query.createDataServiceRequestForOperation('SetPriceBeatOnCartLine', true, EntityClasses.CartClass, 'false', {bypassCache: 'get', returnEntity: 'Entities.Cart'}, {cartId: cartId, cartLine: cartLine, competitorPrice: competitorPrice, competitorUrl: competitorUrl, competitorName: competitorName });
    }

    
    export function setPriceBeatOnCartLineAsync(context: IContext, cartId: string, cartLine: Entities.CartLine, competitorPrice: number, competitorUrl: string, competitorName: string): AsyncResult<Entities.Cart> {
    const request = createSetPriceBeatOnCartLineInput(cartId, cartLine, competitorPrice, competitorUrl, competitorName);
    return callActionOrExecute<Entities.Cart>(request, context.callerContext);
    }
  
    export function createSetPriceBeatRequisitionOnCartLineInput(cartId: string, cartLine: Entities.CartLine, competitorPrice: number, competitorUrl: string, competitorName: string): IDataServiceRequest {
    const query = memxDiscountQuery();
    return query.createDataServiceRequestForOperation('SetPriceBeatRequisitionOnCartLine', true, EntityClasses.CartClass, 'false', {bypassCache: 'get', returnEntity: 'Entities.Cart'}, {cartId: cartId, cartLine: cartLine, competitorPrice: competitorPrice, competitorUrl: competitorUrl, competitorName: competitorName });
    }

    
    export function setPriceBeatRequisitionOnCartLineAsync(context: IContext, cartId: string, cartLine: Entities.CartLine, competitorPrice: number, competitorUrl: string, competitorName: string): AsyncResult<Entities.Cart> {
    const request = createSetPriceBeatRequisitionOnCartLineInput(cartId, cartLine, competitorPrice, competitorUrl, competitorName);
    return callActionOrExecute<Entities.Cart>(request, context.callerContext);
    }
  
    export function createGetChannelMixAndMatchDiscountsInput(queryResultSettings: IQueryResultSettings): IDataServiceRequest {
    const query = memxDiscountQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetChannelMixAndMatchDiscounts', true, DataServiceEntities.MixAndMatchDiscountExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IMixAndMatchDiscount'}, { });
    }

    
    export function getChannelMixAndMatchDiscountsAsync(context: IContext): AsyncResult<DataServiceEntities.IMixAndMatchDiscount[]> {
    const request = createGetChannelMixAndMatchDiscountsInput(
      context.queryResultSettings || {}, );
    return callActionOrExecute<DataServiceEntities.IMixAndMatchDiscount[]>(request, context.callerContext);
    }
  
    export function createGetChannelMixAndMatchDiscountsByProductInput(queryResultSettings: IQueryResultSettings, productId: number): IDataServiceRequest {
    const query = memxDiscountQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetChannelMixAndMatchDiscountsByProduct', true, DataServiceEntities.MixAndMatchDiscountExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IMixAndMatchDiscount'}, {productId: productId });
    }

    
    export function getChannelMixAndMatchDiscountsByProductAsync(context: IContext, productId: number): AsyncResult<DataServiceEntities.IMixAndMatchDiscount[]> {
    const request = createGetChannelMixAndMatchDiscountsByProductInput(
      context.queryResultSettings || {}, productId);
    return callActionOrExecute<DataServiceEntities.IMixAndMatchDiscount[]>(request, context.callerContext);
    }
  
    export function createGetRebatesInput(queryResultSettings: IQueryResultSettings, productIds: number[], active: boolean): IDataServiceRequest {
    const query = memxDiscountQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetRebates', true, DataServiceEntities.RebateFullLineExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IRebateFullLine'}, {productIds: productIds, active: active });
    }

    
    export function getRebatesAsync(context: IContext, productIds: number[], active: boolean): AsyncResult<DataServiceEntities.IRebateFullLine[]> {
    const request = createGetRebatesInput(
      context.queryResultSettings || {}, productIds, active);
    return callActionOrExecute<DataServiceEntities.IRebateFullLine[]>(request, context.callerContext);
    }
  

        // @ts-ignore
        function memxClearanceQuery(inventDimId?: string): DataServiceQuery {
        const key = (inventDimId) ? { InventDimId: inventDimId } :null;
        return new DataServiceQuery("MemxClearance", "ClearanceItem", DataServiceEntities.ClearanceItemExtensionClass, key);
        }

        
    export function createGetAvailableClearanceRefinersInput(queryResultSettings: IQueryResultSettings, criteria: DataServiceEntities.IClearanceSearchCriteria): IDataServiceRequest {
    const query = memxClearanceQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetAvailableClearanceRefiners', true, EntityClasses.ProductRefinerClass, 'true', {bypassCache: 'none', returnEntity: 'Entities.ProductRefiner'}, {criteria: criteria });
    }

    
    export function getAvailableClearanceRefinersAsync(context: IContext, criteria: DataServiceEntities.IClearanceSearchCriteria): AsyncResult<Entities.ProductRefiner[]> {
    const request = createGetAvailableClearanceRefinersInput(
      context.queryResultSettings || {}, criteria);
    return callActionOrExecute<Entities.ProductRefiner[]>(request, context.callerContext);
    }
  
    export function createSearchAvailableClearanceLinesInput(criteria: DataServiceEntities.IClearanceSearchCriteria, skipCount: number, pageSize: number): IDataServiceRequest {
    const query = memxClearanceQuery();
    return query.createDataServiceRequestForOperation('SearchAvailableClearanceLines', true, DataServiceEntities.ClearanceProductSearchResultExtensionClass, 'false', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IClearanceProductSearchResult'}, {criteria: criteria, skipCount: skipCount, pageSize: pageSize });
    }

    
    export function searchAvailableClearanceLinesAsync(context: IContext, criteria: DataServiceEntities.IClearanceSearchCriteria, skipCount: number, pageSize: number): AsyncResult<DataServiceEntities.IClearanceProductSearchResult> {
    const request = createSearchAvailableClearanceLinesInput(criteria, skipCount, pageSize);
    return callActionOrExecute<DataServiceEntities.IClearanceProductSearchResult>(request, context.callerContext);
    }
  

        // @ts-ignore
        function mEMXBuildsQuery(recId?: number): DataServiceQuery {
        const key = (recId) ? { RecId: recId } :null;
        return new DataServiceQuery("MEMXBuilds", "MEMXSystemBuildDetail", DataServiceEntities.MEMXSystemBuildDetailExtensionClass, key);
        }

        
    export function createGetSystemBuildDetailInput(queryResultSettings: IQueryResultSettings, itemId: string, inventSerialId: string): IDataServiceRequest {
    const query = mEMXBuildsQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation('GetSystemBuildDetail', true, DataServiceEntities.MEMXSystemBuildDetailExtensionClass, 'true', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IMEMXSystemBuildDetail'}, {itemId: itemId, inventSerialId: inventSerialId });
    }

    
    export function getSystemBuildDetailAsync(context: IContext, itemId: string, inventSerialId: string): AsyncResult<DataServiceEntities.IMEMXSystemBuildDetail[]> {
    const request = createGetSystemBuildDetailInput(
      context.queryResultSettings || {}, itemId, inventSerialId);
    return callActionOrExecute<DataServiceEntities.IMEMXSystemBuildDetail[]>(request, context.callerContext);
    }
  